module.exports = __webpack_public_path__ + "img/table-ea-icon.0ef8312c.svg";